module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "a4"
    }
  }, [_c('span', [_c('i', [_vm._v("Charming Flowers")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "thin white solid",
      "border-color": "#dbd0cd",
      "padding": ".5ex"
    }
  }, [_c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e9979"
    }
  }, [_c('span', [_c('i', [_vm._v("Vital statistics")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#dbd0cd",
      "border": "thin white solid",
      "border-color": "#936664"
    }
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "border": "0"
    }
  }, [_c('colgroup', [_c('col'), _c('col')]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', [_c('b', [_vm._v("Quilt size:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("66in x 84in")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', [_c('b', [_vm._v("Block size:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("4½in")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', [_c('b', [_vm._v("Number of blocks:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("192")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', [_c('b', [_vm._v("Setting:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("12 blocks x 16 blocks"), _c('br'), _vm._v("plus 6in border")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e10069"
    }
  }, [_c('span', [_vm._v("The following two quilts are made by sewing charm squares together and there can’t be anything much easier than that. They both have some half-square triangles strategically placed and suddenly the quilts come alive. Not a lot of effort for a great reward!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e10349"
    }
  }, [_c('span', [_vm._v("This Charming Flowers quilt uses Lecien’s gorgeous Japanese florals. We have introduced some darker reds as additional fat quarters to make our flowers stand out.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e10589"
    }
  }, [_c('span', [_vm._v("The only thing that you have to remember when combining charm squares with squares made up of two triangles is that they have to be the same "), _c('i', [_vm._v("finished")]), _vm._v(" size.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e10829"
    }
  }, [_c('span', [_vm._v("This sounds obvious but you need to know that if your finished charm squares are 4½in (which they will be if you are using 5in charm packs or dividing a layer cake), your triangles forming the half-square triangle need to be cut from a square measuring 53/8in. Don’t be put off by this as it is no more difficult to cut a square 53/8in than it is to cut a 5in square. If you cut accurately right from the start you will have no need to trim at a later stage – so saving yourself time and effort.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e11569"
    }
  }, [_c('span', [_vm._v("If your charm squares vary from 5in – no problem. When cutting your squares from the fat quarters to make your half-square triangle units, just alter the size of the squares, remembering to add 7/8in to the finished size of your charm pack squares. Therefore if your charm squares are only 4½in (finished size 4in), you will cut 47/8in squares for your half-square triangles.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#dbd0cd",
      "border": "thin white solid",
      "border-color": "#936664",
      "margin-top": "1em"
    }
  }, [_c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e12149"
    }
  }, [_c('span', [_c('i', [_vm._v("What you need")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#f9f7f6",
      "border": "thin white solid",
      "border-color": "#936664"
    }
  }, [_c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e12209"
    }
  }, [_c('span', [_vm._v("• One layer cake "), _c('b', [_c('i', [_vm._v("or ")])]), _c('br'), _vm._v("four charm packs")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d9t0019"
    }
  }, [_c('span', [_vm._v("• Four fat quarters (two light and two dark) for stars")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d9t0039"
    }
  }, [_c('span', [_vm._v("• 2¼yd (2m) fabric for borders and binding")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9780715332085_0009_003",
      "src": "images/9780715332085_0009_003.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e12609"
    }
  }, [_c('span', [_vm._v("opposite:"), _c('br'), _c('b', [_c('i', [_vm._v("Squares are definitely not boring and with a few strategically placed half-square triangles a quick and easy quilt can look absolutely stunning. We chose a lovely floral quilting design to enhance the fabrics. The quilt was pieced by the authors and longarm quilted by The Quilt Room.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9780715332085_0010_001",
      "src": "images/9780715332085_0010_001.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e130211"
    }
  }, [_c('span', [_c('i', [_vm._v("Cutting Instructions")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e130711"
    }
  }, [_c('span', [_c('b', [_vm._v("Layer cake:")]), _c('br'), _vm._v("If you are using a layer cake, rotary cut the 10in square in half in both directions to create four 5in squares, as shown below. You will get 160 squares – eight will be spare and can be used for another project. If you are using charm packs, then you already have your 5in squares cut.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9780715332085_0011_001",
      "src": "images/9780715332085_0011_001.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e134411"
    }
  }, [_c('span', [_c('b', [_vm._v("Border and binding:")])])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e135111"
    }
  }, [_c('span', [_vm._v("• Cut four strips lengthways 6½in wide.")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e135911"
    }
  }, [_c('span', [_vm._v("• Cut four strips lengthways 2½in wide.")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e136711"
    }
  }, [_c('span', [_vm._v("When using large florals in a border, it’s preferable not to have any joins.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e137911"
    }
  }, [_c('span', [_c('b', [_vm._v("Seam allowance:")])])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e139111"
    }
  }, [_c('span', [_vm._v("• Use scant ¼in seams throughout.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e140111"
    }
  }, [_c('span', [_c('i', [_vm._v("Making the Half-square Triangle Units")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e140911"
    }
  }, [_c('span', [_c('b', [_vm._v("1. ")]), _vm._v("Layer a dark and light fat quarter with right sides together, as shown below, with the light fabric on the top, lining up the top and left-hand side.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9780715332085_0011_002",
      "src": "images/9780715332085_0011_002.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e142911"
    }
  }, [_c('span', [_c('b', [_vm._v("2. ")]), _vm._v("Press to keep the two layers together. Don’t be over zealous when trimming any selvedge as you need 21½in across to be able to cut four strips.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e145411"
    }
  }, [_c('span', [_c('b', [_vm._v("3. ")]), _vm._v("Cut four strips 53/8in wide. Sub-cut each strip into three squares each 53/8in x 53/8in. You need ten squares from each fat quarter – two are spare.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e149711"
    }
  }, [_c('span', [_c('b', [_vm._v("4.")]), _vm._v(" Keeping the two layers of each square together, mark a line across the diagonal of the light fabric.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e151211"
    }
  }, [_c('span', [_c('b', [_vm._v("5. ")]), _vm._v("Stitch either side of this marked line with a scant ¼in seam allowance.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9780715332085_0011_003",
      "src": "images/9780715332085_0011_003.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e152911"
    }
  }, [_c('span', [_c('i', [_vm._v("Assembling your Quilt")])])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e153411"
    }
  }, [_c('span', [_vm._v("• Lay out all your charm squares in sixteen rows of twelve, referring to the diagram, right to see where to place your half-square triangle units.")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e155811"
    }
  }, [_c('span', [_vm._v("• Some of the stars were made up using just one dark fabric and some were made up by alternating both the dark fabrics. When happy with the layout, label the first square of each row with the row number, to ensure they stay in the correct order after sewing.")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e159711"
    }
  }, [_c('span', [_vm._v("• Sew the squares into rows and then join the rows together, pinning at every intersection to ensure that there is a perfect match. Press the work.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e162711"
    }
  }, [_c('span', [_c('i', [_vm._v("Sewing your Borders")])])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e163211"
    }
  }, [_c('span', [_vm._v("• Refer to page 123 for adding your borders.")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e164211"
    }
  }, [_c('span', [_vm._v("• Your quilt top is now complete. Quilt as desired and bind to finish (see "), _c('span', {
    attrs: {
      "href": "#/Lint_9780715332085_epub_c25_r1#d7e18035131",
      "id": "d14e385",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quilting")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e165211"
    }
  }, [_c('span', [_c('b', [_vm._v("6")]), _vm._v(". Press to set the stitches and then cut along the marked line.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e166511"
    }
  }, [_c('span', [_c('b', [_vm._v("7. ")]), _vm._v("Trim dog ears and open, pressing towards the dark fabric. You will get twenty units.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9780715332085_0011_004",
      "src": "images/9780715332085_0011_004.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e168211"
    }
  }, [_c('span', [_c('b', [_vm._v("8. ")]), _vm._v("Repeat with the other two fat quarters to create another twenty units. You need forty in total.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9780715332085_0011_005",
      "src": "images/9780715332085_0011_005.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9780715332085_0011_006",
      "src": "images/9780715332085_0011_006.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9780715332085_0012_001",
      "src": "images/9780715332085_0012_001.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc6d8c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lint_9780715332085_epub_c6_r1.vue
// module id = 78
// module chunks = 0